/**
 * 进程管理
 */
const SupplierRouter = {
  path: '/purchase',
  component: () => import('@/views/layout'),
  redirect: '/administration/purchase/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [

    {
      path: '/administration/purchase/add_list',
      name: 'addList',
      component: () => import('@/views/administration_manage/purchase_manage/list/add_list'),
      hidden: true,
      meta: {
        title: '新增供应商'
      }
    },
    {
      path: '/administration/purchase/edit_list/:id',
      name: 'editList',
      component: () => import('@/views/administration_manage/purchase_manage/list/add_list'),
      hidden: true,
      meta: {
        title: '编辑供应商'
      }
    },
    {
      path: '/administration/purchase/details/:id',
      name: 'purchase_details',
      component: () => import('@/views/administration_manage/purchase_manage/list/details'),
      hidden: true,
      meta: {
        title: '详情'
      }
    },
    {
      path: '/administration/purchase/go_goods',
      name: 'goGoods',
      component: () => import('@/views/administration_manage/purchase_manage/components/go_goods'),
      hidden: true,
      meta: {
        title: '采购物品'
      }
    }

  ]
}

export default SupplierRouter
